// 'use strict';

// /*---LEFT BAR ACCORDION----*/
(function($) {
if (!$) {
  throw new Error("jQuery not found");
}

  $(document).ready(function() {
    window.gfcmsUI = {
      setupSidebarToggle: setupSidebarToggle,
      setupAccordion: setupAccordion
    };
    window.gfcmsUI.setupSidebarToggle();
    //setupNicescroll();
    window.gfcmsUI.setupAccordion();
  });

  function setupAccordion() {
     $('#nav-accordion').dcAccordion({
         eventType: 'click',
         autoClose: true,
         saveState: true,
         disableLink: true,
         speed: 'slow',
         showCount: false,
         autoExpand: true,
         cookie: 'dcjq-accordion-1',
         classExpand: 'dcjq-current-parent'
     });
   }

  // $(function() {
  //     $('#sidebar .sub-menu > a').click(function() {
  //       var o = ($(this).offset());
  //       var diff = 250 - o.top;
  //       if (diff > 0) {
  //         $('#sidebar').scrollTo('-= '+ Math.abs(diff), 500);
  //       } else {
  //         $('#sidebar').scrollTo('+=' + Math.abs(diff), 500);
  //       }
  //     });
  //   });


  //custom select box

  // function setupCustomSelect() {
//   $('select.styled').customSelect();
// }


  function setupSidebarToggle() {
    $(document).on('click', '.sidebar-menu  a', function(event) {
      var $element = $(event.target);

      var wSize = $(window).width();
      var isParent = $element.hasClass('dcjq-parent') ||
        $element.hasClass('dcjq-parent-li') ||
        !!$element.parents('.dcjq-parent').length;
      if (wSize <= 768 && !isParent) {
        $('#main-content').css({
          'margin-left': '0px'
        });
        $('#sidebar').css({
          'margin-left': '-210px'
        });

        if ($element.closest('a').attr('href') !== 'javascript:;') {
          $('#sidebar > ul').hide();
          $('#container').addClass('sidebar-closed');
        }
      }
    });
  }

  function setupNicescroll() {
    $('html').removeClass('no-js');
    $('html').niceScroll({
      styler: 'fb',
      cursorcolor: '#4ECDC4',
      cursorwidth: '6',
      cursorborderradius: '10px',
      background: '#404040',
      spacebarenabled: false,
      cursorborder: '',
      zindex: '1000'
    });
  }


  //    sidebar toggle
  // $(function() {
  //   function responsiveView() {
  //     var wSize = $(window).width();
  //     if (wSize <= 768) {
  //       $('#container').addClass('sidebar-close');
  //       $('#sidebar > ul').hide();
  //     }
  //
  //     if (wSize > 768) {
  //       $('#container').removeClass('sidebar-close');
  //       $('#sidebar > ul').show();
  //     }
  //   }
  //   $(window).on('load', responsiveView);
  //   $(window).on('resize', responsiveView);
  // });

  // $('.fa-bars').click(function() {
  //   if ($('#sidebar > ul').is(":visible") === true) {
  //     $('#main-content').css({
  //       'margin-left': '0px'
  //     });
  //     $('#sidebar').css({
  //       'margin-left': '-210px'
  //     });
  //     $('#sidebar > ul').hide();
  //     $("#container").addClass("sidebar-closed");
  //   } else {
  //     $('#main-content').css({
  //       'margin-left': '210px'
  //     });
  //     $('#sidebar > ul').show();
  //     $('#sidebar').css({
  //       'margin-left': '0'
  //     });
  //     $("#container").removeClass("sidebar-closed");
  //   }
  // });

  // custom scrollbar
  /* $("#sidebar").niceScroll({styler:"fb",cursorcolor:"#4ECDC4", cursorwidth: '3',
                cursorborderradius: '10px', background: '#404040', spacebarenabled:false, cursorborder: ''});
  $("html").niceScroll({styler:"fb",cursorcolor:"#4ECDC4",
                cursorwidth: '6', cursorborderradius: '10px', background:
                '#404040', spacebarenabled:false,  cursorborder: '', zindex: '1000'});*/

  // widget tools

  // jQuery('.panel .tools .fa-chevron-down').click(function() {
  //   var el = jQuery(this).parents(".panel").children(".panel-body");
  //   if (jQuery(this).hasClass("fa-chevron-down")) {
  //     jQuery(this).removeClass("fa-chevron-down").addClass("fa-chevron-up");
  //     el.slideUp(200);
  //   } else {
  //     jQuery(this).removeClass("fa-chevron-up").addClass("fa-chevron-down");
  //     el.slideDown(200);
  //   }
  // });

  // jQuery('.panel .tools .fa-times').click(function() {
  //   jQuery(this).parents(".panel").parent().remove();
  // });


  // //    tool tips
  // $('.tooltips').tooltip();
  //
  // //    popovers
  // $('.popovers').popover();



  // custom bar chart
  // if ($(".custom-bar-chart")) {
  //   $(".bar").each(function() {
  //     var i = $(this).find(".value").html();
  //     $(this).find(".value").html("");
  //     $(this).find(".value").animate({
  //       height: i
  //     }, 2000)
  //   })
  // }


})(window.jQuery)
